import {BankDetailsFormField} from "../types/bank-details-form-field.types";
import {FormRowKey} from "../../../../types/form-field.types";
import {Validators} from "@angular/forms";

export const bankDetailsRowKeys: Array<FormRowKey> = [
  {
    key: 'first'
  },
  {
    key: 'second'
  },
  {
    key: 'third',
    className: 'form-row-two'
  },
  {
    key: 'fourth'
  },
  {
    key: 'fifth'
  },
  {
    key: 'sixth',
    isHidden: true
  },
  {
    key: 'seventh',
    isHidden: true
  },
  {
    key: 'eighth',
    isHidden: true
  }
]

export const bankDetailsFormFields: Array<BankDetailsFormField> = [
  {
    label: 'Контрагент',
    fieldName: 'partner',
    validators: [ Validators.required ],
    type: 'text',
    rowKey: 'first'
  },
  {
    label: 'ИНН Контрагента',
    fieldName: 'partnerInn',
    type: 'number',
    rowKey: 'first'
  },
  {
    label: 'Тип юр. лица',
    fieldName: 'legalEntityType',
    type: 'select',
    rowKey: 'first'
  },
  {
    label: 'БИК',
    fieldName: 'bic',
    type: 'number',
    rowKey: 'second'
  },
  {
    label: 'Наименование Банка',
    fieldName: 'bankName',
    type: 'text',
    rowKey: 'second'
  },
  {
    label: '№ Счета в банке',
    fieldName: 'accountNumber',
    type: 'text',
    rowKey: 'second'
  },
  {
    label: 'Комментарий',
    fieldName: 'comment',
    type: 'text',
    rowKey: 'third',
    className: 'comment'
  },
  {
    label: 'КПП',
    fieldName: 'kpp',
    type: 'number',
    rowKey: 'third'
  },
  {
    label: 'Телефон',
    fieldName: 'phone',
    type: 'tel',
    rowKey: 'fourth'
  },
  {
    label: 'Почта для документов',
    fieldName: 'mail',
    type: 'text',
    rowKey: 'fourth'
  },
  {
    label: 'Рег. адрес',
    fieldName: 'registrationAddress',
    type: 'text',
    rowKey: 'fourth'
  },
  {
    label: 'ОГРНИП',
    fieldName: 'registerNumber',
    type: 'text',
    rowKey: 'fifth'
  },
  {
    label: 'Корр. счёт',
    fieldName: 'correspondentAccountNumber',
    type: 'text',
    rowKey: 'fifth'
  },
  {
    label: 'Паспорт',
    fieldName: 'passportExist',
    type: 'button',
    rowKey: 'fifth'
  },
  {
    label: 'ФИО',
    fieldName: 'fio',
    type: 'text',
    rowKey: 'sixth'
  },
  {
    label: 'Серия номер паспорта',
    fieldName: 'seriesNumber',
    type: 'text',
    rowKey: 'sixth'
  },
  {
    label: 'Дата выдачи',
    fieldName: 'grandDate',
    type: 'date',
    rowKey: 'sixth'
  },
  {
    label: 'Дата рождения',
    fieldName: 'birthDate',
    type: 'date',
    rowKey: 'seventh'
  },
  {
    label: 'Место выдачи паспорта',
    fieldName: 'passportIssuance',
    type: 'text',
    rowKey: 'seventh'
  },
  {
    label: 'Код подразделения',
    fieldName: 'departmentCode',
    type: 'text',
    rowKey: 'seventh'
  },
  {
    label: 'Место рождения',
    fieldName: 'birthPlace',
    type: 'text',
    rowKey: 'eighth'
  }
]
